<template>
  <Dialog
    v-model:visible="visible"
    :style="{ width: '450px' }"
    :header="header"
    :modal="true"
  >
    <div class="flex align-items-center justify-content-center">
      <i
        class="pi pi-exclamation-triangle mr-3"
        style="font-size: 2rem"
      />
      <span>{{ message }}</span>
    </div>
    <template #footer>
      <Button
        label="No"
        icon="pi pi-times"
        class="p-button-text"
        @click="visible = false"
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        class="p-button-text"
        @click="$emit('confirm')"
      />
    </template>
  </Dialog>
</template>

<script setup>
defineProps({
  header: { type: String, default: 'Confirm' },
  message: { type: String, default: '' }
})

defineEmits(['confirm'])

const visible = defineModel('visible', { type: Boolean, default: false })
</script>
